import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { ChevronDown, LayoutGrid } from "lucide-react";
import { useS } from "../../lib/simple";
import { navGroups } from "../../lib/navGroups";

export function ToolsAccordion() {
  const { s } = useS();
  const [open, setOpen] = useState(false);
  return (
    <div className="lb-card p-2" data-testid="home-tools">
      <button onClick={() => setOpen((o) => !o)} data-testid="home-tools-toggle" aria-expanded={open}
        className="w-full flex items-center gap-3 min-h-[56px] px-3 rounded-xl text-left hover:bg-white/5 transition-colors">
        <LayoutGrid size={18} className="text-neon shrink-0" />
        <span className="flex-1 min-w-0">
          <span className="block font-semibold">{s("tools_title")}</span>
          <span className="block text-xs text-[hsl(var(--muted-foreground))]">{s("tools_sub")}</span>
        </span>
        <ChevronDown size={18} className={`shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="grid sm:grid-cols-3 gap-3 p-2 pt-1">
          {navGroups(s).map((g) => (
            <div key={g.id} className="rounded-xl bg-white/[0.02] border border-white/5 p-3" data-testid={`home-tools-${g.id}`}>
              <p className="font-semibold text-sm">{g.title}</p>
              <p className="text-xs text-[hsl(var(--muted-foreground))] mb-2">{g.sub}</p>
              {g.items.map((it) => (
                <NavLink key={it.id} to={it.to} data-testid={`home-tool-${it.id}`}
                  className="flex items-center gap-2.5 min-h-[44px] px-2 rounded-lg text-sm text-white/85 hover:bg-white/5 hover:text-white">
                  <it.icon size={16} className="text-neon shrink-0" /> <span className="flex-1">{it.label}</span>
                  {it.advanced && <span className="text-[10px] px-1.5 py-0.5 rounded bg-white/5 text-[hsl(var(--muted-foreground))]">{s("advanced")}</span>}
                </NavLink>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
